import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './artikeltexte-did.reducer';

export const ArtikeltexteDIDDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const artikeltexteDIDEntity = useAppSelector(state => state.artikeltexteDID.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="artikeltexteDIDDetailsHeading">
          <Translate contentKey="integrawebApp.artikeltexteDID.detail.title">ArtikeltexteDID</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{artikeltexteDIDEntity.id}</dd>
          <dt>
            <span id="createdDate">
              <Translate contentKey="integrawebApp.artikeltexteDID.createdDate">Created Date</Translate>
            </span>
          </dt>
          <dd>
            {artikeltexteDIDEntity.createdDate ? (
              <TextFormat value={artikeltexteDIDEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="integrawebApp.artikeltexteDID.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{artikeltexteDIDEntity.createdBy}</dd>
          <dt>
            <span id="lastModifiedDate">
              <Translate contentKey="integrawebApp.artikeltexteDID.lastModifiedDate">Last Modified Date</Translate>
            </span>
          </dt>
          <dd>
            {artikeltexteDIDEntity.lastModifiedDate ? (
              <TextFormat value={artikeltexteDIDEntity.lastModifiedDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="lastModifiedBy">
              <Translate contentKey="integrawebApp.artikeltexteDID.lastModifiedBy">Last Modified By</Translate>
            </span>
          </dt>
          <dd>{artikeltexteDIDEntity.lastModifiedBy}</dd>
        </dl>
        <Button tag={Link} to="/artikeltexte-did" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/artikeltexte-did/${artikeltexteDIDEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ArtikeltexteDIDDetail;
